import { useSelector } from "react-redux";
import { Alert, Box } from "@mui/material";
import { adminFinanceManagedByBursar } from "../utils/staffRoles";

/**
 * Admin finance routes — always visible. Shows a note when a bursar records day-to-day entries.
 */
export default function FinanceAdminOnly({ children }) {
    const { currentUser } = useSelector((state) => state.user);
    const { teachersList } = useSelector((state) => state.teacher);
    const managedByBursar = adminFinanceManagedByBursar(currentUser, teachersList, {
        requireProfileCompleted: true,
    });

    return (
        <Box>
            {managedByBursar ? (
                <Alert severity="info" sx={{ mx: { xs: 2, sm: 3 }, mt: 2, borderRadius: 2 }}>
                    Your bursar handles day-to-day collections and expenses. As director, use{" "}
                    <strong>Fee setup → Apply fees to all students</strong> after structures are ready so every learner
                    is billed. The bursar cannot run that step.
                </Alert>
            ) : null}
            {children}
        </Box>
    );
}
